import { Spin } from "antd";
import React, { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllProjectSize } from "../../redux/slices/general/generalAction";
import { percentValue } from "../../helpers/operationMath";
import { PieChartGeneral } from "./PieChartGeneral";

export const PieChartSizeProject = () => {
	const {
		general: {
			projectSize,
			loadings: { graph },
		},
	} = useSelector((state) => state);
	const dispatch = useDispatch();

	const getAllSize = useCallback(() => {
		dispatch(getAllProjectSize());
	}, [dispatch]);

	useEffect(() => {
		getAllSize();
	}, [getAllSize]);

	if (graph) {
		return (
			<>
				<div className="flex justify-center items-center  sm:w-[320px]  sm:h-[320px] md:w-[360px]  md:h-[360px] ">
					<Spin size="large" />
				</div>
			</>
		);
	} else {
		return (
			<PieChartGeneral
				className={"sm:w-[320px]  sm:h-[320px] md:w-[360px]  md:h-[360px]  [grid-area:graphic]"}
				pieChartProps={{
					enableArcLinkLabels: false,
					enableArcLabels: false,
					margin: { top: 16, right: 16, bottom: 16, left: 16 },
					data: projectSize,
					layers: ["arcs", "arcLabels", "arcLinkLabels", "legends", CenteredMetric],
					activeInnerRadiusOffset: 8,
					innerRadius: 0.5,
					animate: true,
					arcLabel: (d) => `${d.id}`,
					valueFormat: (value) => {
						const sumReduce = projectSize.reduce((total, item) => (total += item.value), 0);
						const percent = percentValue(sumReduce, value);
						return `${percent}%`;
					},
					colors: (parent, child) => {
						if (parent.data.color) {
							return parent.data.color;
						}
						return "#ccc";
					},
				}}
			/>
		);
	}
};

const CenteredMetric = ({ dataWithArc, centerX, centerY }) => {
	let total = 0;
	dataWithArc.forEach((datum) => {
		total += datum.value;
	});

	return (
		<text
			x={centerX}
			y={centerY}
			textAnchor="middle"
			dominantBaseline="central"
			style={{
				fontSize: "24px",
				fontWeight: 600,
			}}
		>
			{total} proyectos
		</text>
	);
};
